import left from './left';
import right from './right';
import down from './down';
import rotate from './rotate';
import space from './space';
import s from './s';
import r from './r';
import p from './p';
import vibrate from '../../unit/vibrate';

const feedback = {
  left: 14,
  down: 14,
  rotate: 18,
  right: 14,
  space: 35,
  r: 24,
  p: 18,
  s: 14,
};

const withFeedback = (control, key) => Object.assign({}, control, {
  down(store) {
    vibrate(feedback[key]);
    control.down(store);
  },
});

const todo = {
  left,
  down,
  rotate,
  right,
  space,
  r,
  p,
  s,
};

Object.keys(todo).forEach((key) => {
  todo[key] = withFeedback(todo[key], key);
});

export default todo;



// WEBPACK FOOTER //
// ./src/control/todo/index.js